import ModelCatalog from "../../components/components-model/ModelCatalog";
import { useDocumentMeta } from "../../hooks/useDocumentMeta";
import PublicLayout from "../../layouts/PublicLayout";

/**
 * Vitrina pública: cualquier visitante puede navegar los perfiles.
 *
 * Comparte parrilla con el listado de salas (<ModelCatalog />); aquí el marco
 * es el del sitio y la tarjeta lleva al perfil.
 */
export default function ModelsCatalog() {
    useDocumentMeta({
        title: "Nuestras Modelos",
        description:
            "Explora los perfiles de las modelos de Afrodita Models (Estudio Afrodita, Armenia, Quindío): fotos, videos y transmisiones en vivo. Ver los perfiles es gratis.",
        keywords: [
            "modelos Afrodita",
            "Afrodita Models modelos",
            "modelos webcam Armenia",
            "modelos webcam Quindío",
            "transmisiones en vivo",
            "Estudio Afrodita",
        ],
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Modelos de Afrodita Models",
            description:
                "Perfiles de las modelos del estudio Afrodita Models en Armenia, Quindío.",
            url: "https://www.afroditamodels.com/modelos",
            isPartOf: { "@id": "https://www.afroditamodels.com/#website" },
            about: { "@id": "https://www.afroditamodels.com/#organization" },
        },
    });

    return (
        <PublicLayout>
            <ModelCatalog variant="public" />
        </PublicLayout>
    );
}
